<template>
    <div>
        <div class="row">
            <div class="col-12 col-lg-5">
                <div class="row">
                    <div class="col-12 col-sm-3 col-lg-5 course-logo-link-div">
                        <router-link class="course-logo-link" to="/schedule">
                            <img
                                    class="home-kurs-img lazyloaded"
                                    style="max-width: 100%;"
                                    src="@/assets/hometeacher/images/online-teacher-logo-list.png"
                            >
                        </router-link>
                    </div>

                    <div class="col-12 col-sm-9 col-lg-7 home-kurs">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="h2kurs pb-2">
                                    <img class="easy" :src="require(`@/assets/hometeacher/images/easy.png`)">
                                    <router-link to="/schedule">
                                        Абонемент OnlineTeacher
                                    </router-link>
                                </h2>
                                <p>{{ $t('Language') }}: <span class="strong-black">Английский</span></p>
                                <p>{{ $t('Age') }}: <span class="strong-black">1-3, 4-8, 9-12&nbsp;лет</span></p>
                                <p>{{ $t('Lessons_') }}: <span class="strong-black">любые по расписанию</span></p>
                                <p>{{ $t('Age') }}: <span class="strong-black">30-60&nbsp;мин</span></p>
                                <p>{{ $t('Course_duration') }}: <span class="strong-black">1-6&nbsp;мес.</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-5 kurs">
                Игровой английский, опытные преподаватели и увлекательные авторские программы. Для детей от 1
                года до 12 лет «живые» онлайн-уроки в реальном времени. Наши уроки максимально приближены к
                очному обучению и так же эффективны. Абонемент открывает безлимитный доступ ко всем
                онлайн-занятиям в расписании: English, Art Class, Music Class, Story Time. В первые <strong>3
                дня</strong> для
                новых клиентов <strong>все занятия бесплатны</strong>!
            </div>

            <div class="col-12 col-lg-2 zapis">
                <base-button v-if="subscription" @click="order" class="ma-0"
                             :data-id="subscription.idsubscription"
                             data-model="subscription"
                             :data-price="subscription.price"
                             data-action="order"
                             :data-label="$t('sign_up')"
                >
                    {{ $t('sign_up') }}
                </base-button>
                <p v-if="subscription">
                    <span class="cena">{{ subscription.price | formatPrice }}</span>{{ $t('cur') }}
                    <span class="rub"><s>{{ subscription.pricebefore | formatPrice }}{{ $t('cur') }}</s></span>
                </p>
            </div>
        </div>

        <div class="row" v-if="!lastItem">
            <div class="col-12">
                <div class="land-t-delimeter"></div>
            </div>
        </div>
    </div>
</template>

<script>


    import subscctionApi from "../data/SubscriptionApi";
    import numeral from 'numeral';

    export default {
        name: "CourseListSubscriptionItem",
        props: {
            title: String,
            lastItem: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                subscription: null,
            }
        },

        mounted() {
            subscctionApi.fetchSubscription(2)
                .then(response => {
                    this.subscription = response
                })
        },

        methods: {
            order() {
                this.$emit('order')
            },
        },

        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        }
    }
</script>

<style scoped>
    .h2kurs {
        cursor: pointer;
    }

    .course-logo-link {
        display: inline-block;
    }

    .course-logo-link-div {
        text-align: center;
    }

    @media (max-width: 580px) {
        .easy {
            margin: 0 auto;
        }
    }
</style>

<style src="@/assets/hometeacher/css/main.css">
</style>
